import api from '@/utils/axios';

export const fetchPositions = async ({
  page = 1,
  limit = 10,
  search = '',
  department_id = null,
  sortField = 'id',
  sortOrder = 'DESC',
  include_inactive = 0,
} = {}) => {
  const response = await api.post('positions/get', {
    page,
    limit,
    search,
    department_id,
    sortField,
    sortOrder,
    include_inactive: include_inactive ? 1 : 0,
  });

  if (!response.data?.success) {
    throw new Error(response.data?.error?.message || 'Failed to fetch positions');
  }

  const data = response.data.data || {};
  return {
    positions: Array.isArray(data.positions) ? data.positions : [],
    total: Number(data.total || 0),
    page: Number(data.page || page),
    limit: Number(data.limit || limit),
    summary: data.summary || null,
  };
};

export const createPosition = async (payload) => {
  const response = await api.post('positions/manage', {
    action: 'create',
    ...payload
  });
  if (!response.data?.success) {
    throw new Error(response.data?.error?.message || 'Failed to create position');
  }
  return response.data.data;
};

export const updatePosition = async (payload) => {
  const response = await api.post('positions/manage', {
    action: 'update',
    ...payload
  });
  if (!response.data?.success) {
    throw new Error(response.data?.error?.message || 'Failed to update position');
  }
  return response.data.data;
};

export const updatePositionStatus = async ({ position_id, is_active }) => {
  const response = await api.post('positions/manage', {
    action: 'update_status',
    position_id,
    is_active: is_active ? 1 : 0
  });
  if (!response.data?.success) {
    throw new Error(response.data?.error?.message || 'Failed to update position status');
  }
  return response.data.data;
};

export const deletePosition = async ({ position_id }) => {
  const response = await api.post('positions/manage', {
    action: 'delete',
    position_id
  });
  if (!response.data?.success) {
    throw new Error(response.data?.error?.message || 'Failed to delete position');
  }
  return response.data.data;
};
